"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Projectile = void 0;
var pixi_js_1 = require("pixi.js");
var rxjs_1 = require("rxjs");
var app_1 = require("../../app");
var Colliders_1 = require("../Colliders");
var helpers_1 = require("../../helpers");
var projectiles_1 = require("../../data/projectiles");
var Projectile = function (_a) {
    var startPos = _a.startPos, targetPos = _a.targetPos, _b = _a.maxLifetimeTicks, maxLifetimeTicks = _b === void 0 ? 8 : _b, name = _a.name, viableTargets = _a.viableTargets, onCollide = _a.onCollide, onDestroy = _a.onDestroy;
    var projectileData = projectiles_1.projectiles[name];
    if (!projectileData) {
        console.error("Projectile ".concat(name, " not found."));
    }
    var spriteContainer = app_1.appService.spriteContainer, physicsUpdate = app_1.appService.physicsUpdate, gameTicks$ = app_1.appService.gameTicks$;
    var sprite = pixi_js_1.Sprite.from(projectileData.url);
    sprite.width = projectileData.width;
    sprite.height = projectileData.height;
    sprite.x = startPos.x;
    sprite.y = startPos.y;
    spriteContainer.addChild(sprite);
    var dx = targetPos.x - startPos.x;
    var dy = targetPos.y - startPos.y;
    var angle = Math.atan2(dy, dx);
    sprite.rotation = angle;
    var force = (0, helpers_1.normalizeForce)({ x: dx, y: dy });
    var moveProjectile = physicsUpdate.subscribe(function () {
        if (sprite.destroyed)
            return;
        sprite.x += force.x * projectileData.speed;
        sprite.y += force.y * projectileData.speed;
        viableTargets.find(function (target) {
            if (!target.sprite.destroyed && (0, Colliders_1.isIntersectingRect)(sprite, target.sprite, -20)) {
                onCollide === null || onCollide === void 0 ? void 0 : onCollide(target);
                destroyProjectile();
                return true;
            }
        });
    });
    var destroyProjectile = function () {
        if (sprite.destroyed)
            return;
        moveProjectile.unsubscribe();
        sprite.destroy();
        onDestroy === null || onDestroy === void 0 ? void 0 : onDestroy();
    };
    gameTicks$
        .pipe((0, rxjs_1.take)(maxLifetimeTicks))
        .subscribe(null, null, destroyProjectile);
    return { moveProjectile: moveProjectile };
};
exports.Projectile = Projectile;
